export const utms = {
  utmSource: 'utm_source',
  utmMedium: 'utm_medium',
  utmCampaign: 'utm_campaign',
  utmTerm: 'utm_term',
  utmContent: 'utm_content',
  utmUrl: 'utm_url',
}

export const marketingQueryParams = {
  leadSource: 'lead_source',
  leadSubsourceSf: 'lead_subsource_sf',
  paidmediaGclid: 'paidmedia_gclid',
  paidmediaFbclid: 'paidmedia_fbclid',
  paidmediaMsclkid: 'paidmedia_msclkid',
  paidmediaGacid: 'paidmedia_gacid',
}

export const UTM_KEY_TYPE = 'KEY'
export const UTM_KEY_VALUE = 'VALUE'

export const utmMap = ({
  data,
  keyType = UTM_KEY_TYPE,
  location,
  queryParams,
}) => {
  const utmQueryParam = Object.keys(data).reduce((acc, key) => {
    const dataValue = data[key]
    const utmValue =
      key === 'utmUrl' ? location.pathname : queryParams.get(dataValue)
    const finalKey = keyType === UTM_KEY_TYPE ? key : dataValue

    if (utmValue) {
      acc[finalKey] = utmValue
    }

    return acc
  }, {})

  return utmQueryParam
}
